//
// # Schema Version
//
// `SchemaVersion` is the string LITERAL, not `string`. Content types declare
// `schemaVersion: SchemaVersion`, so the typia validators check the version as
// part of ordinary validation; widening it disables that everywhere at once.
//
// The string is a git commit short-hash. Nothing resolves it.
//

export const SCHEMA_VERSION = "f6a6e2d9b66b" as const;

export type SchemaVersion = typeof SCHEMA_VERSION;
